export const datatableStyles = {
    datatable: {
        paper: {
            width: "100%",
            display: "table",
            tableLayout: "fixed",
        },
        tableBox: {
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px",
        },
    },
}